export function cleanAuthorizationParameters(url) {
    for (const parameter of ["code", "state", "error", "error_description"]) {
        url.searchParams.delete(parameter);
    }
    return url;
}
export function isAuthorizationCallbackUrl(value) {
    let url;
    try {
        url = new URL(value);
    }
    catch {
        return false;
    }
    return url.searchParams.has("state")
        && (url.searchParams.has("code") || url.searchParams.has("error"));
}
export function authorizationCallbackState(value) {
    try {
        const state = new URL(value).searchParams.get("state");
        return state && state.length > 0 ? state : null;
    }
    catch {
        return null;
    }
}
export function authorizationReturnToFromProblem(problem) {
    if (!problem.details
        || typeof problem.details !== "object"
        || Array.isArray(problem.details))
        return undefined;
    const returnTo = problem.details.return_to;
    return typeof returnTo === "string" ? returnTo : undefined;
}
